<template>
      <div class="worksheetTypeDefinitionCreate">
        <v-breadcrumbs>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
            >Home</v-breadcrumbs-item
          >
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'worksheetTypeDefinition', params: {} }">
          Worksheet Type Definition
          </v-breadcrumbs-item>
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :to="{ name: 'worksheetTypeDefinitionCreate', params: {} }">
            Worksheet Type Definition
          </v-breadcrumbs-item>
        </v-breadcrumbs>

        <v-card>
          <v-card-title>Worksheet Type Definition</v-card-title>
          <v-card-text>
            <worksheetTypeDefinition-form></worksheetTypeDefinition-form>
          </v-card-text>
        </v-card>
      </div>
    </template>
    <script>
    import WorksheetTypeDefinitionForm from './WorksheetTypeDefinitionForm.vue';

    export default {
      name: 'worksheetTypeDefinition',
      components: {
        WorksheetTypeDefinitionForm
      },
      created() {
        this.$emit("showParent", false);
      }
    }
    </script>
    